import React from "react"
import PropTypes from "prop-types"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import {
  AGNOSTIC_CARE_ARTICLES,
  CARE_HOME_ARTICLES,
  DEMENTIA_CARE_HOME_ARTICLES,
  HOME_CARE_ARTICLES,
} from "./articles_list"
import Icon from "../../../layout/icon"
import SmartLink from "../../../layout/SmartLink/SmartLink"
import Row from "../../../layout/Row/Row"
import {
  BodyText,
  InlineText,
  SubTitle,
  Title,
} from "../../../Typography/Typography"
import Separator from "../../../Separator/Separator"
import { CARE_SUPPORT_URL } from "../../../../utils/paths"

const articleLinkClickEvent = (targetPath, articleTitle) => ({
  name: "SEO - Filtered Directory - Article Link Clicked",
  properties: {
    "Target Path": targetPath,
    "Article Title": articleTitle,
  },
})

const ArticleLink = ({ to, header, snippet }) => (
  <>
    <SubTitle serif bold>
      {header}
    </SubTitle>
    <BodyText marginBottom>{snippet}</BodyText>
    <Row smReverse>
      <SmartLink to={to} clickEvent={articleLinkClickEvent(to, header)}>
        <InlineText brand>
          Read more <Icon icon={faChevronRight} />
        </InlineText>
      </SmartLink>
    </Row>
    <Separator />
  </>
)

const articleTypes = {
  care_home: CARE_HOME_ARTICLES,
  home_care: HOME_CARE_ARTICLES,
  agnostic: AGNOSTIC_CARE_ARTICLES,
  dementia: DEMENTIA_CARE_HOME_ARTICLES,
}

const getArticles = ({ regulatoryBody, pageType }) => {
  const articlesList = articleTypes[pageType] || articleTypes.agnostic

  return articlesList.filter(
    (article) =>
      article.filter.regulatoryBody === undefined ||
      article.filter.regulatoryBody === regulatoryBody,
  )
}

const allGuidanceLinkClickEvent = (targetPath) => ({
  name: "SEO - Filtered Directory - All Guidance Link Clicked",
  properties: {
    "Target Path": targetPath,
  },
})

const Articles = ({ regulatoryBody, pageType }) => {
  const FilteredArticles = getArticles({ regulatoryBody, pageType })
  return (
    <>
      <div>
        <Title>
          Expert advice for care in{" "}
          {regulatoryBody === "ci" ? "Scotland" : "England"}
        </Title>

        {FilteredArticles.map((article) => (
          <ArticleLink
            key={article.header}
            to={article.to}
            header={article.header}
            snippet={article.snippet}
          />
        ))}

        <SmartLink
          to={CARE_SUPPORT_URL}
          clickEvent={allGuidanceLinkClickEvent(CARE_SUPPORT_URL)}
        >
          <InlineText brand>
            Go to all info and guidance <Icon icon={faChevronRight} />
          </InlineText>
        </SmartLink>
      </div>
    </>
  )
}
export default Articles

Articles.propTypes = {
  regulatoryBody: PropTypes.oneOf(["ci", "cqc"]).isRequired,
  pageType: PropTypes.oneOf(["home_care", "care_home", "dementia"]),
}

Articles.defaultProps = {
  pageType: null,
}

ArticleLink.propTypes = {
  to: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  snippet: PropTypes.string.isRequired,
}
